<div class="operators-list-container">
    <!-- Loading State -->
    @if (isLoading) {
    <div class="flex flex-col items-center justify-center py-12 space-y-4">
        <mat-spinner diameter="50" class="custom-spinner"></mat-spinner>
        <div class="text-center">
            <h3 class="text-lg font-medium text-gray-900 mb-2">Loading operators...</h3>
            <p class="text-gray-500">Please wait while we fetch the operator data.</p>
        </div>
    </div>
    }

    <!-- Operators List -->
    @else if (operators && operators.length > 0) {
    <div class="space-y-4">
        <!-- Mobile Layout (Single Column) -->
        @if (isHandset()) {
        <div class="space-y-3">
            @for (operator of operators; track operator.id) {
            <app-parking-operator-item [operator]="operator" (edit)="onEditOperator($event)"
                (delete)="onDeleteOperator($event)" (viewDetails)="onViewOperatorDetails($event)"
                (assignParkingSpace)="onAssignParkingSpace($event)"
                (unassignParkingSpace)="onUnassignParkingSpace($event)">
            </app-parking-operator-item>
            }
        </div>
        }

        <!-- Desktop/Tablet Layout (Grid) -->
        @else {
        <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6">
            @for (operator of operators; track operator.id) {
            <app-parking-operator-item [operator]="operator" (edit)="onEditOperator($event)"
                (delete)="onDeleteOperator($event)" (viewDetails)="onViewOperatorDetails($event)"
                (assignParkingSpace)="onAssignParkingSpace($event)"
                (unassignParkingSpace)="onUnassignParkingSpace($event)">
            </app-parking-operator-item>
            }
        </div>
        }

        <!-- Pagination -->
        @if (paginationConfig) {
        <div class="flex justify-center mt-6 pt-6 border-t border-gray-200">
            <mat-paginator [length]="paginationConfig.totalItems" [pageSize]="paginationConfig.itemsPerPage"
                [pageIndex]="paginationConfig.currentPage" [pageSizeOptions]="[10, 20, 50, 100]"
                [showFirstLastButtons]="!isHandset()" (page)="onPageChange($event)" class="bg-transparent">
            </mat-paginator>
        </div>
        }
    </div>
    }

    <!-- Empty State -->
    @else {
    <div class="text-center py-12">
        <div class="flex flex-col items-center space-y-4">
            <mat-icon class="text-6xl text-gray-400">group</mat-icon>
            <div class="space-y-2">
                <h3 class="text-lg font-medium text-gray-900">No operators found</h3>
                <p class="text-gray-500 max-w-sm">
                    No parking operators match your current filters. Try adjusting your search criteria or create a new
                    operator.
                </p>
            </div>
        </div>
    </div>
    }
</div>